export default __webpack_public_path__ + "static/media/juwai_logo_only.ebd127cd.png";